// React
import BannerButlleti from 'modules/website/shared/components/BannerButlleti';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import HomeBannersButtons from 'modules/website/pages/Home/components/HomeBannersButtons';
import SliderNoticies from 'modules/website/pages/Home/components/SliderNoticies';
import BannerTerritori from 'modules/website/pages/Home/components/BannerTerritori';
import PolitiquesSectorials from 'modules/website/pages/Home/components/PolitiquesSectorials';
import BannerHomeLaCatDelSi from 'modules/website/pages/Home/components/BannerHomeLaCatDelSi';

const noMarginNoPadding = { marginTop: '0px', paddingTop: '0px', marginBottom: '0px' };

const centered = {
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: 0,
};

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="home__container main__page">
      <section>
        <SliderNoticies />
      </section>

      <section style={noMarginNoPadding}>
        <HomeBannersButtons />
      </section>

      <BannerTerritori />

      <section>
        <Link to="/butlleti">
          <BannerButlleti />
        </Link>
      </section>

      <section style={centered}>
        <PolitiquesSectorials />
      </section>

      <section style={noMarginNoPadding}>
        <BannerHomeLaCatDelSi />
      </section>
    </div>
  );
}

export default Home;
